import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable, of, Subject, tap } from 'rxjs';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { User, UserRole } from '../models/user';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ExchangeCodeRequest } from '../models/exchangeCode';
import { JwtService } from './jwt.service';

@Injectable({ providedIn: 'root' })
export class LoginService {
  public user: User = new User();
  public accessToken: string = '';

  public loginSubject: Subject<User | undefined> = new Subject();

  constructor(public http: HttpClient, private jwtService: JwtService) { }

  exchangeCode(body: ExchangeCodeRequest): Observable<void> {
    const url = `${environment.apiUrl}exchangeCode`;
    return this.http.post<void>(url, body);
  }


  logout(): void {
    this.user = new User();
    this.accessToken = '';
    localStorage.removeItem('jwt');
    this.loginSubject.next(undefined);
  }

  login(idToken: string): Observable<User> {
    const url = `${environment.apiUrl}login`;
    return this.http.post<User>(url, idToken).pipe(
      tap((accessToken: any) => {
        const decodedToken = this.jwtService.decodeToken(accessToken.token);
        this.user.id = decodedToken.id;
        this.user.email = decodedToken.email;
        this.user.picture = decodedToken.picture;
        this.user.firstName = decodedToken.given_name;
        this.user.lastName = decodedToken.family_name;

        var userRole = Number(decodedToken.role);
        this.user.role = userRole;
        this.loginSubject.next(this.user);
        // TODO: Do we need any other user values set here?
        console.log('Decoded Token:', decodedToken);
        this.accessToken = accessToken.token;
        localStorage.setItem("jwt", accessToken.token);
      }),
      map(value => {
        return this.user;
      })
    );
  }
}
